import { useEffect } from 'react';

const UmamiAnalytics = () => {
  const websiteId = process.env.REACT_APP_UMAMI_WEBSITE_ID;
  // Use Apache reverse proxy URL instead of direct port
  const umamiUrl = process.env.REACT_APP_UMAMI_URL || 'http://localhost';

  useEffect(() => {
    if (!websiteId) {
      return;
    }

    if (document.querySelector(`script[data-website-id="${websiteId}"]`)) {
      return;
    }

    const script = document.createElement('script');
    script.async = true;
    script.src = `${umamiUrl}/umami/script.js`;
    script.setAttribute('data-website-id', websiteId);
    script.setAttribute('data-auto-track', 'true');
    script.setAttribute('data-do-not-track', 'true');
    
    document.head.appendChild(script);

    return () => {
      const existingScript = document.querySelector(`script[data-website-id="${websiteId}"]`);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, [websiteId, umamiUrl]);

  return null; // This component doesn't render anything
};

/**
 * Custom hook for tracking events
 * 
 * Usage:
 * const trackEvent = useUmamiTracker();
 * trackEvent('button-click', { button: 'download', file: 'data.zip' });
 */
export const useUmamiTracker = () => {
  return (eventName, eventData = {}) => {
    if (window.umami) {
      window.umami.track(eventName, eventData);
    }
  };
};

/**
 * Track custom page view
 * 
 * Usage:
 * const trackPageView = useUmamiPageView();
 * trackPageView('/custom-path', 'Custom Page Title');
 */
export const useUmamiPageView = () => {
  return (url, title) => {
    if (window.umami) {
      window.umami.track(props => ({
        ...props,
        url: url || window.location.pathname,
        title: title || document.title
      }));
    }
  };
};

export default UmamiAnalytics;
